import { StackProps, VStack } from '@chakra-ui/react';
import * as React from 'react';

import { Post } from './components/Post';

export const Posts: React.FC<StackProps> = ({ ...stackProps }) => {
  return (
    <VStack spacing="4" {...stackProps}>
      {Array(5)
        .fill(0)
        .map((_, i) => (
          <Post key={i} width="full" />
        ))}
    </VStack>
  );
};
